import React, { useState, useContext } from 'react'
import { Formik, Form } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import * as Yup from 'yup'
import { AppContext } from '../App'
import { CustomCheckbox, CustomEmail } from './productTypes/resinous/resinousFormInputs'

export default function QuoteModals() {
   const { 
      setCurrentStep,
      setLinkGoBackTarget,
      setProductOptionsSelected,
      setCoverageDetails,
      setStepsCompleted,
      setSelectedChip,
      setSelectedColor,
      setAppHeader,
      setChipValue,
      setColorValue
   } = useContext(AppContext)

   const [emailSent, setEmailSent] = useState(false)
   const iconEmailWhite = <FontAwesomeIcon icon={ faEnvelope } color="#ffffff" />

   const handleEmailQuoteSubmit = (values) => {
      //Send the email value and checkbox status to the URL. On success response update the content in the modal via this component's state.
      setEmailSent(true)
   }

   const handleCreateNewQuote = () => {
      setLinkGoBackTarget({ link: "productTypeSelection" })
      setCurrentStep({ step: "productTypeSelection" })
      setProductOptionsSelected({ productOptions: [""] })
      setCoverageDetails()
      setStepsCompleted(["Select Application"])
      setChipValue()
      setSelectedChip()
      setColorValue()
      setSelectedColor()
      setAppHeader("") // What type of product would you like to estimate?
   }

   return (
      <React.Fragment>
         <div className="modal fade" id="modal-email" tabIndex="-1" role="dialog" aria-labelledby="modal-email" aria-hidden="true">
               <div className="modal-dialog" role="document">
                  <div className="modal-content">
                     <div className="modal-header">
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                           <span aria-hidden="true">&times;</span>
                        </button>
                        <h3 className="modal-title">{ emailSent===false ? "Email project supplies breakdown" : "Email Sent!" }</h3>
                     </div>
                     <div className="modal-body">
                           <div className="row p-1">
                              <div className="col-xs-12 col-sm-8 col-sm-push-2 text-center">
                                 {
                                    emailSent===false ? (
                                       <React.Fragment>
                                          <p className="lead">Include relevant data sheets and installation documents?</p>
                                          <Formik
                                                initialValues={{
                                                   relevantDocuments: "true",
                                                   email: ''
                                                }} 
                                                validateOnChange={false}
                                                validateOnBlur={false}
                                                validationSchema={Yup.object({
                                                   email: Yup.string()
                                                      .email('Email is invalid')
                                                      .required('Email is required')
                                                })}
                                                onSubmit={ (values) => { handleEmailQuoteSubmit(values) } }    
                                          >
                                          { // Render props
                                                props => (
                                                   <Form>
                                                      <CustomCheckbox name="relevantDocuments">
                                                            Yes, send me all relevant documents
                                                      </CustomCheckbox>
                                                      <CustomEmail name="email" placeholder="Email" />
                                                      <button type="submit" className="btn btn-primary btn-lg">SEND EMAIL { iconEmailWhite }</button>
                                                   </Form>
                                                )
                                          }
                                          </Formik>
                                       </React.Fragment>
                                    ) : (
                                       <React.Fragment>
                                          <p>Project supplies breakdown for resinous flooring has been sent to [EMAIL]. </p>
                                          <button type="button" className="btn btn-primary btn-lg" data-bs-toggle="button" data-bs-dismiss="modal" aria-label="Close" aria-pressed="false">CLOSE</button>
                                       </React.Fragment>
                                    )
                                 }
                              </div>
                           </div>
                     </div>
                  </div>
               </div>
         </div>
         <div className="modal" id="modal-new-quote" tabIndex="-1" role="dialog" aria-labelledby="modal-new-quote" aria-hidden="true">
               <div className="modal-dialog" role="document">
                  <div className="modal-content">
                     <div className="modal-header">
                           <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                           </button>
                           <h3 className="modal-title">Create a new quote?</h3>
                     </div>
                     <div className="modal-body">
                           <div className="row p-1">
                              <div className="col-xs-12 col-sm-8 col-sm-push-2">
                                 <p>Creating a new quote will erase this quote. Be sure to email, download, or add items to cart to prevent loss of quote.</p>
                              </div>
                              <div className="col-xs-12 col-sm-8 col-sm-push-2">
                                 <div className="row p-1">
                                       <div className="col-xs-6">
                                          <button type="button" className="btn btn-block btn-primary" data-bs-toggle="button" data-bs-dismiss="modal" aria-label="Close" aria-pressed="false" onClick={ handleCreateNewQuote }>YES, DELETE</button>
                                       </div>
                                       <div className="col-xs-6">
                                          <button type="button" className="btn btn-block btn-secondary" data-bs-toggle="button" data-bs-dismiss="modal" aria-label="Close" aria-pressed="false">NO, GO BACK</button>
                                       </div>
                                 </div>
                              </div>
                           </div>
                     </div>
                  </div>
               </div>
         </div>
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/QuoteModals.js